export const REPORTS_ROUTES = {
  __ROOT__: '/reports',
  VIEW_REPORT: '/reports/view/:reportId',
}
